<template>
  <div class="page-container">
    <Sidebar />
    <div class="main-content">
      <div class="page-header">
        <h1>采集日志</h1>
        <div class="header-actions">
          <button class="refresh-btn" @click="fetchData" :disabled="loading">刷新</button>
        </div>
      </div>

      <div class="status-summary">
        <div class="summary-card">
          <h3>最近请求</h3>
          <div class="requests-list">
            <div v-for="req in requests" :key="req.id" class="request-item" :class="req.status">
              <span class="request-type">{{ req.request_type }}</span>
              <span class="request-status">{{ req.status }}</span>
              <span class="request-time">{{ formatTime(req.requested_at) }}</span>
              <span v-if="req.completed_at" class="complete-time">完成: {{ formatTime(req.completed_at) }}</span>
            </div>
          </div>
        </div>

        <div class="summary-card">
          <h3>最近采集结果</h3>
          <div class="logs-list">
            <div v-for="log in recentLogs" :key="log.created_at" class="log-item" :class="log.log_type">
              <span class="log-type">{{ log.log_type }}</span>
              <span class="log-price-type">{{ log.price_type }}</span>
              <span class="log-message">{{ log.message }}</span>
              <span class="log-time">{{ formatTime(log.created_at) }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="logs-section">
        <h3>详细日志</h3>
        <div class="filter-bar">
          <select v-model="filterRequestId" @change="fetchLogs">
            <option value="">全部请求</option>
            <option v-for="req in requests" :key="req.id" :value="req.id">
              请求 #{{ req.id }} - {{ req.request_type }}
            </option>
          </select>
        </div>
        <div class="logs-table">
          <div class="log-row header">
            <span class="col-time">时间</span>
            <span class="col-type">类型</span>
            <span class="col-price">价格类型</span>
            <span class="col-message">消息</span>
            <span class="col-data">数据</span>
          </div>
          <div v-for="log in logs" :key="log.id" class="log-row" :class="log.log_type">
            <span class="col-time">{{ formatTime(log.created_at) }}</span>
            <span class="col-type tag" :class="log.log_type">{{ log.log_type }}</span>
            <span class="col-price">{{ log.price_type }}</span>
            <span class="col-message">{{ log.message }}</span>
            <span class="col-data">
              <button v-if="log.data" class="view-data-btn" @click="showData(log)">查看</button>
            </span>
          </div>
        </div>
      </div>

      <div v-if="showDataModal" class="modal">
        <div class="modal-content">
          <h3>日志数据</h3>
          <pre>{{ JSON.stringify(selectedLogData, null, 2) }}</pre>
          <button class="close-btn" @click="showDataModal = false">关闭</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue'
import axios from 'axios'
import { getAdminPassword } from '../utils/api'

export default {
  name: 'CrawlLogs',
  components: { Sidebar },
  data() {
    return {
      loading: false,
      requests: [],
      recentLogs: [],
      logs: [],
      filterRequestId: '',
      showDataModal: false,
      selectedLogData: null
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const response = await axios.get('/api/admin/crawl-rankings-status', {
          headers: { 'x-admin-password': getAdminPassword() }
        })
        if (response.data.code === 200) {
          this.requests = response.data.data.requests
          this.recentLogs = response.data.data.logs
        }
        await this.fetchLogs()
      } catch (err) {
        console.error('获取数据失败:', err)
      } finally {
        this.loading = false
      }
    },
    async fetchLogs() {
      try {
        const url = this.filterRequestId
          ? `/api/admin/crawl-logs?requestId=${this.filterRequestId}`
          : '/api/admin/crawl-logs'
        const response = await axios.get(url, {
          headers: { 'x-admin-password': getAdminPassword() }
        })
        if (response.data.code === 200) {
          this.logs = response.data.data
        }
      } catch (err) {
        console.error('获取日志失败:', err)
      }
    },
    formatTime(time) {
      if (!time) return ''
      return new Date(time).toLocaleString('zh-CN')
    },
    showData(log) {
      this.selectedLogData = log.data
      this.showDataModal = true
    }
  }
}
</script>

<style scoped>
.page-container { display: flex; min-height: 100vh; background: #f5f5f5; }
.main-content { flex: 1; padding: 30px; margin-left: 260px; }
.page-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; }
.page-header h1 { font-size: 24px; color: #2c3e50; }
.refresh-btn { background: #3498db; color: white; border: none; padding: 8px 16px; border-radius: 6px; cursor: pointer; }
.refresh-btn:disabled { background: #bdc3c7; }

.status-summary { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 30px; }
.summary-card { background: white; padding: 20px; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); }
.summary-card h3 { margin: 0 0 15px 0; font-size: 16px; color: #2c3e50; }

.requests-list, .logs-list { display: flex; flex-direction: column; gap: 10px; }
.request-item, .log-item { display: flex; gap: 15px; padding: 10px; background: #f8f9fa; border-radius: 6px; font-size: 14px; }
.request-item.pending { border-left: 3px solid #f39c12; }
.request-item.completed { border-left: 3px solid #27ae60; }
.request-item.failed { border-left: 3px solid #e74c3c; }
.log-item.success { border-left: 3px solid #27ae60; }
.log-item.error { border-left: 3px solid #e74c3c; }

.logs-section { background: white; padding: 20px; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); }
.logs-section h3 { margin: 0 0 15px 0; }
.filter-bar { margin-bottom: 15px; }
.filter-bar select { padding: 8px 12px; border: 1px solid #ddd; border-radius: 6px; }

.logs-table { display: flex; flex-direction: column; gap: 8px; }
.log-row { display: grid; grid-template-columns: 150px 80px 80px 1fr 80px; gap: 15px; padding: 12px 15px; background: #f8f9fa; border-radius: 6px; font-size: 13px; align-items: center; }
.log-row.header { background: #2c3e50; color: white; font-weight: 600; }
.log-row.start { border-left: 3px solid #3498db; }
.log-row.fetch { border-left: 3px solid #9b59b6; }
.log-row.parse { border-left: 3px solid #f39c12; }
.log-row.upload { border-left: 3px solid #1abc9c; }
.log-row.success { border-left: 3px solid #27ae60; background: #e8f5e9; }
.log-row.error { border-left: 3px solid #e74c3c; background: #ffebee; }

.tag { padding: 4px 8px; border-radius: 4px; font-size: 12px; font-weight: 500; }
.tag.start { background: #3498db; color: white; }
.tag.fetch { background: #9b59b6; color: white; }
.tag.parse { background: #f39c12; color: white; }
.tag.upload { background: #1abc9c; color: white; }
.tag.success { background: #27ae60; color: white; }
.tag.error { background: #e74c3c; color: white; }

.view-data-btn { background: #3498db; color: white; border: none; padding: 4px 8px; border-radius: 4px; font-size: 12px; cursor: pointer; }

.modal { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; }
.modal-content { background: white; padding: 30px; border-radius: 10px; max-width: 600px; max-height: 80vh; overflow: auto; }
.modal-content h3 { margin: 0 0 15px 0; }
.modal-content pre { background: #f8f9fa; padding: 15px; border-radius: 6px; overflow: auto; font-size: 12px; }
.close-btn { background: #e74c3c; color: white; border: none; padding: 8px 16px; border-radius: 6px; cursor: pointer; margin-top: 15px; }
</style>